import { useTranslation } from 'react-i18next';

export default function ComunidadSection() {
  const { t } = useTranslation();

  return (
    <section className="py-12 md:py-16 px-6 md:px-10 bg-[#EDE7DE]">
      <div className="w-full max-w-4xl mx-auto">

        {/* ── Tarjeta compacta "tipo sábana" ── */}
        <div className="bg-white rounded-2xl border border-[#DCCDBF]/60 overflow-hidden">

          {/* ── Cabecera compacta ── */}
          <div className="bg-[#F9F7F3] px-6 md:px-10 py-5 md:py-6 border-b border-[#DCCDBF]/40">
            <span className="inline-block font-sans text-[10px] font-semibold text-terracotta uppercase tracking-[0.2em] mb-1.5">
              {t('home.comunidad.tag')}
            </span>
            <h3 className="font-serif text-sm md:text-base font-bold text-terracotta mb-0.5">
              {t('home.comunidad.huevos')}
            </h3>
            <h2 className="font-serif text-xl md:text-2xl font-bold text-[#8B6F5C] leading-tight">
              {t('home.comunidad.title')}
            </h2>
          </div>

          {/* ── Cuerpo: dos columnas ── */}
          <div className="p-6 md:p-10">
            <div className="flex flex-col lg:flex-row items-center gap-8 md:gap-10">

              {/* ── Columna de texto ── */}
              <div className="flex-1 text-center lg:text-left">

                <p className="font-sans text-sm md:text-base text-[#3D2B1F] leading-relaxed mb-4 max-w-xl lg:max-w-none">
                  {t('home.comunidad.desc1')}
                </p>

                <div className="grid grid-cols-2 sm:grid-cols-4 gap-3 mb-5 max-w-xl lg:max-w-none">
                  <div className="flex flex-col items-center lg:items-start gap-1.5 bg-[#F9F7F3] rounded-xl px-3 py-3">
                    <div className="w-8 h-8 flex items-center justify-center text-[#8B6F5C]">
                      <i className="ri-plant-line text-lg" />
                    </div>
                    <span className="font-sans text-[11px] font-semibold text-[#8B6F5C] text-center lg:text-left leading-tight">
                      {t('home.comunidad.libre_jaula')}
                    </span>
                  </div>
                  <div className="flex flex-col items-center lg:items-start gap-1.5 bg-[#F9F7F3] rounded-xl px-3 py-3">
                    <div className="w-8 h-8 flex items-center justify-center text-[#8B6F5C]">
                      <i className="ri-sun-line text-lg" />
                    </div>
                    <span className="font-sans text-[11px] font-semibold text-[#8B6F5C] text-center lg:text-left leading-tight">
                      {t('home.comunidad.aire_libre')}
                    </span>
                  </div>
                  <div className="flex flex-col items-center lg:items-start gap-1.5 bg-[#F9F7F3] rounded-xl px-3 py-3">
                    <div className="w-8 h-8 flex items-center justify-center text-[#8B6F5C]">
                      <i className="ri-seedling-line text-lg" />
                    </div>
                    <span className="font-sans text-[11px] font-semibold text-[#8B6F5C] text-center lg:text-left leading-tight">
                      {t('home.comunidad.pastura')}
                    </span>
                  </div>
                  <div className="flex flex-col items-center lg:items-start gap-1.5 bg-[#F9F7F3] rounded-xl px-3 py-3">
                    <div className="w-8 h-8 flex items-center justify-center text-[#8B6F5C]">
                      <i className="ri-shield-check-line text-lg" />
                    </div>
                    <span className="font-sans text-[11px] font-semibold text-[#8B6F5C] text-center lg:text-left leading-tight">
                      {t('home.comunidad.senasa')}
                    </span>
                  </div>
                </div>

                <p className="font-sans text-sm text-[#3D2B1F] leading-relaxed mb-3 max-w-xl lg:max-w-none">
                  {t('home.comunidad.beneficios')}
                </p>

                <p className="font-sans text-sm text-[#5C4A3A] leading-relaxed mb-5 max-w-xl lg:max-w-none">
                  {t('home.comunidad.caba')}
                </p>

                {/* ── Sorteo ── */}
                <div className="bg-[#C58D72]/8 rounded-xl p-4 md:p-5 mb-6 border border-[#C58D72]/15 max-w-xl lg:max-w-none">
                  <div className="flex items-start gap-3">
                    <div className="w-7 h-7 flex-shrink-0 flex items-center justify-center text-lg mt-0.5">
                      🥚
                    </div>
                    <p className="font-sans text-sm text-[#3D2B1F] leading-relaxed">
                      {t('home.comunidad.sorteo')}
                    </p>
                  </div>
                </div>

                {/* ── Botones ── */}
                <div className="flex flex-col sm:flex-row items-center gap-3 lg:justify-start">
                  <a
                    href="https://wa.me/5492357431380"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center justify-center bg-[#8B6F5C] text-white px-7 py-3 rounded-full font-sans text-sm font-semibold hover:bg-[#7A5F4E] transition-colors duration-300 whitespace-nowrap"
                  >
                    <i className="ri-whatsapp-line mr-2 text-lg" />
                    {t('home.comunidad.whatsapp')}
                  </a>
                </div>

                <div className="mt-4">
                  <a
                    href="https://www.instagram.com/timotenatural"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center font-sans text-sm font-semibold text-terracotta hover:text-brown transition-colors duration-300"
                  >
                    <i className="ri-instagram-line mr-1.5 text-lg" />
                    {t('home.comunidad.instagram')}
                  </a>
                </div>
              </div>

              {/* ── Imagen ── */}
              <div className="flex-shrink-0 flex items-center justify-center">
                <div className="w-64 md:w-72 lg:w-80 rounded-xl overflow-hidden bg-[#F9F7F3] border border-[#DCCDBF]/40">
                  <img
                    src="https://storage.readdy-site.link/project_files/33950b86-7657-493b-8177-e5932d2de9a1/229f550e-0399-46ca-9c5b-bda8652a3b8c_IMG-20260604-WA0090.jpg?v=26e7a43293afac577aaa759381729377"
                    alt="Timote Natural — Huevos de campo"
                    className="w-full h-auto object-contain"
                  />
                </div>
              </div>

            </div>
          </div>

        </div>

      </div>
    </section>
  );
}